import React, { useEffect, useState } from 'react';
import { Route, Routes } from 'react-router';
import { SavedProductsHome } from './SavedProductsHome';
type Props = {};

export function SavedProductsIndex() {
  return (
    <>
      <Routes>
        {/* <Route path="/saved-products/:id" element={<OrderHistoryDetailView />} /> */}
        <Route path="/" element={<SavedProductsHome />} />
      </Routes>
    </>
  );
}
